import React from 'react'
import PropTypes from 'prop-types'
import { Announcement, Section, Strong } from './PartnershipCertificateDialog.styles'

/**
 * The important information' component.
 */
const ImportantInformation = props => {
  const { completed, error, failed, loading } = props

  return (
    <>
      {!error && !loading && (
        <Section margin="24px 0 0">
          <Announcement>
            {!!completed && (
              <>
                <Strong>Importante</Strong>: Esta información fue generada automáticamente, con datos al momento de
                aceptar la orden de compra por el proveedor, o últimos datos disponible en mercado público. El
                porcentaje podría no sumar 100%, considerando que los socios con participación menor al 10% no son
                visibles en la presente tabla.
              </>
            )}
            {!completed && !failed && (
              <>
                <Strong>Importante</Strong>: Esta información esta siendo generada. Por favor, consulta en unos minutos
                más.
              </>
            )}
          </Announcement>
        </Section>
      )}
    </>
  )
}

ImportantInformation.defaultProps = {
  completed: true,
  datesGenerated: '',
  error: false,
  failed: false,
  loading: false,
  mechanismType: ''
}

ImportantInformation.propTypes = {
  completed: PropTypes.bool,
  error: PropTypes.bool,
  failed: PropTypes.bool,
  loading: PropTypes.bool
}

export default ImportantInformation
